module.exports = __webpack_public_path__ + "media/images/lb/484-c04001ffd84e518febd77f381a6b9054.svg";